export default __webpack_public_path__ + "static/media/profile.316a818a.svg";